import { injectGlobal } from 'styled-components';
import 'antd/lib/popconfirm/style/css';
import 'antd/lib/message/style/css';
import 'antd/lib/dropdown/style/css';
import 'antd/lib/modal/style/css';
import 'antd/lib/input/style/css';
import 'antd/lib/form/style/css';
import 'antd/lib/divider/style/css';
import 'antd/lib/date-picker/style/css';
import 'antd/lib/menu/style/css';
import 'antd/lib/switch/style/css';
import 'antd/lib/auto-complete/style/css';
import 'antd/lib/collapse/style/css';
import 'antd/lib/tabs/style/css';
import 'antd/lib/button/style/css';
import 'antd/lib/popover/style/css';
import 'antd/lib/checkbox/style/css';
import 'antd/lib/upload/style/css';
import 'antd/lib/rate/style/css';
import 'antd/lib/breadcrumb/style/css';
import 'antd/lib/pagination/style/css';
import 'antd/lib/notification/style/css';
import 'antd/lib/layout/style/css';

import 'react-quill/dist/quill.snow.css';

import { theme } from './theme';

// eslint-disable-next-line
injectGlobal`
  @import url('https://fonts.googleapis.com/css?family=Rubik:300,400,500,700');

  html, body {
    margin: 0;
    height: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    overflow: visible;
    background-color: ${theme.colors.white} !important;
    color: ${theme.colors.fontSilverPrimary} !important;
  }

  * {
    box-sizing : border-box;
    font-family: '${theme.fonts.primary}', sans-serif;
  }

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  .ant-dropdown::before {
    position: relative;
  }

  .ant-select-dropdown .select-all {
    color: ${theme.colors.fontLinkHover};
    border-bottom: 1px solid ${theme.colors.borderLightestSilver};

    & i {
      display: none;
    }
  }

  .ant-popover-contacts-details {
    z-index: 1000;
    .ant-popover-inner-content {
      padding: 12px 0;
    }
  }

  .ant-tooltip-inner {
    font-size: 12px;
    background: #3e464f;
  }
  .ant-tooltip-arrow {
    border-bottom-color: #3e464f !important;
  }
  
  .sidebar-menu-tooltip {
    .ant-tooltip-inner {
      height: 50px;
      display: flex;
      align-items: center;

      font-size: 14px;
      border-radius: unset;

      background: ${theme.colors.darkColor};
    }

    .ant-tooltip-arrow {
      display: none
    }
    
    &.ant-tooltip-placement-right, .ant-tooltip-placement-rightTop, .ant-tooltip-placement-rightBottom {
      left: 60px !important;
      padding-left: unset;
    }
  }
  
  .popover-action {
    .ant-popover-inner-content {
      width: 350px;
    }
  }

  .ant-pagination-item {
    min-width: 24px;
    height: 24px;
    margin: 0;
    line-height: 22px;
  }
  .ant-pagination-item-active {
    font-weight: 400;
  }

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #cccbcb; 
  }
`;



// WEBPACK FOOTER //
// ./src/styles/global-styles.js